import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { BookingChrome } from "@features/booking/layouts/BookingChrome";

/**
 * 404 — wraps the standard BookingChrome card so the not-found page reads
 * as part of the system, not a fallback template. Voice (§2): confident
 * restaurant-domain copy, no apology. Visual (§3): "Premium from restraint"
 * — no giant 404 number dominating the page, just a small eyebrow marker
 * and a serif headline doing the work.
 */
const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('errors');

  return (
    <BookingChrome>
      <div className="px-6 py-16 sm:py-20 flex flex-col items-center text-center">
        {/* Eyebrow — small, on-brand, sets context without shouting */}
        <span className="text-xs font-medium tracking-[0.2em] uppercase text-brand mb-4">
          {t('NOT_FOUND_EYEBROW')}
        </span>

        {/* Serif headline carries the personality */}
        <h1 className="font-display text-3xl sm:text-4xl text-foreground mb-3 leading-tight max-w-md">
          {t('NOT_FOUND_TITLE')}
        </h1>

        <p className="text-foreground/60 mb-10 max-w-sm">
          {t('NOT_FOUND_MESSAGE')}
        </p>

        <button
          type="button"
          className="btn-primary inline-flex items-center gap-2"
          onClick={() => navigate("/")}
        >
          <ArrowLeft size={16} aria-hidden="true" />
          {t('NOT_FOUND_RETURN_HOME')}
        </button>
      </div>
    </BookingChrome>
  );
};

export default NotFound;
